module.exports = __webpack_public_path__ + "img/seklab.58508f07.png";